<template>
  <v-navigation-drawer v-model="drawer" v-bind="ToolbarIsMobile" app>
    <v-app-bar text class="toolbar">
      <v-spacer></v-spacer>
      <router-link
        :to="{ name: 'Inicio Empresas' }"
        class="text black--text text-center"
        style="text-decoration: none"
      >
        <v-toolbar-title>Bolsa de Trabajo</v-toolbar-title>
        <v-toolbar-title>Empresas</v-toolbar-title>
      </router-link>
      <v-spacer></v-spacer>
    </v-app-bar>
    <template v-slot:append v-if="getPerfil.empresa">
      <v-list-item three-line>
        <v-list-item-avatar size="60">
          <img
            :src="
              getPerfil.empresa.logo ? getPerfil.empresa.logo : getStaticProfile
            "
          />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{
            getPerfil.empresa.nombreEmpresa
          }}</v-list-item-title>
          <v-list-item-subtitle
            >{{ getPerfil.nombres }}
            {{ getPerfil.apellidoPaterno }}</v-list-item-subtitle
          >
          <v-list-item-subtitle>{{ getPerfil.cargo }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-list nav>
      <v-list-item-group :value="getMenuIndex">
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          :to="{ name: item.routerName }"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-title text>{{ item.name }}</v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "UserHomeDrawer",

  props: {
    items: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      visible: false,
      drawer: false
    };
  },

  methods: {
    ...mapActions("auth", ["logout"]),
    ...mapActions("user", ["fetchUbicationData"])
  },

  computed: {
    ToolbarIsMobile() {
      // const vm = this
      const binding = {};
      if (this.$vuetify.breakpoint.smAndDown) {
        binding.temporary = true;
      } else {
        binding.fixed = true;
        this.drawer = true;
      }
      return binding;
    },

    getMenuIndex() {
      return this.$route.meta.menuIndex;
    },

    getStaticProfile() {
      return require("@/assets/anonymous.png");
    },

    ...mapGetters("user", ["getUserInfo", "getError", "fetching"]),
    ...mapGetters("company", ["getPerfil"])
  },

  async mounted() {
    await this.fetchUbicationData();
  }
};
</script>
